import React from 'react';
import { Check } from 'lucide-react';

const benefits = [
  'Unified workspace combining AI chat, smart notes and lists, task management, moodboards and bookmarks',
  'AI that learns and adapts to your project management style',
  'Seamless team collaboration with real-time project sharing',
  'Intelligent bookmarking to organize important resources and references',
  'Visual organization with customizable moodboards',
  'Seamless voice and text interactions for natural workflow',
  'Intelligent document analysis and context management',
  'Flexible tools that grow with your project needs',
];

export function Benefits() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-32">
      <div className="bg-gray-800/50 backdrop-blur-xl rounded-2xl p-12 border border-gray-700">
        <h2 className="text-3xl font-bold text-white mb-12 font-['Sora']">Why Choose Zentime?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map(benefit => (
            <div key={benefit} className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-lg bg-blue-600/20 flex-shrink-0 flex items-center justify-center">
                <Check size={18} className="text-green-500" />
              </div>
              <span className="text-gray-300 text-lg">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
